// extracted by mini-css-extract-plugin
export default {"pageHeader":"Finanzen_pageHeader__o+9C1","grid":"Finanzen_grid__Cem5G"};